<template>
    <div class="content-body customers-wrapper customer-list">
        <b-row>
            <b-col md="12">
                <b-button
                    variant="primary new-button"
                    v-b-modal="'new-hotline'">
                    + New Hotline
                </b-button>
            </b-col>
        </b-row>
        <div class="mt-3">
            <div class="data-container">
                <b-table 
                    :items="list"
                    :fields="fields"
                    :current-page="page">
                    <template slot="visibility" slot-scope="data">
                        <switches
                            :value="data.item.visibility"
                            theme="custom"
                            color="primary"
                            type-bold="true"
                            text-enabled="On"
                            text-disabled="Off">
                        </switches>
                    </template>
                    <template slot="action" slot-scope="data">
                        <b-button
                            variant="ghost btn-table-edit"
                            @click="getHotline(data.item.uuid)">
                        </b-button>
                        <b-button
                            variant="ghost btn-table-delete"
                            @click="confirmDelete(data.item.uuid)">
                        </b-button>
                    </template>
                </b-table>
            </div>
<!--             <div>
                <b-row>
                    <b-col>
                        <div class="mt-1">
                            <span class="pagination-indicator">Showing {{ startList }} to {{ endList }} of {{ maxPage }} per page</span>
                        </div>
                    </b-col>
                    <b-col>
                        <b-pagination 
                        hide-goto-end-buttons 
                        align="right" 
                        size="md" 
                        :total-rows="maxPage * list.length"
                        :limit="5"
                        :per-page="list.length"
                        @change="paginate"
                        :value="page"
                        class="custom-pagination">
                        </b-pagination>
                    </b-col>
                </b-row>
            </div> -->
        </div>
        <b-modal
            id="new-hotline"
            title="New Hotline"
            ref="createModal"
            @shown="clearForm"
            centered>
            <b-container fluid>
                <div class="modal-form">
                    <b-form>
                        <b-row no-gutters>
                            <b-col sm="12" md="3">
                                <h6 class="main-label">Hotline No.</h6>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    label="Landline or Mobile No."
                                    label-for="hotline"
                                    :state="isValid('hotline')"
                                    :invalid-feedback="errorMessage('hotline')"
                                    class="secondary-label">
                                    <b-form-input
                                        type="text"
                                        v-model="form.hotline"
                                        required
                                        maxlength="15">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col>
                                <hr class="form-divider">
                            </b-col>
                        </b-row>
                        <b-row no-gutters>
                            <b-col sm="12" md="3">
                                <h6 class="main-label">Visibility</h6>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    label="Publish in App"
                                    label-for="visibility"
                                    class="secondary-label">
                                    <switches
                                        v-model="form.visibility"
                                        theme="custom"
                                        color="primary"
                                        type-bold="true"
                                        text-enabled="On"
                                        text-disabled="Off">
                                    </switches>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </b-container>
            <div slot="modal-footer">
                <b-btn variant="ghost" v-bind:disabled="loading" @click="handleCancel('new-hotline')" class="mr-1 btn-cancel">
                    Cancel
                </b-btn>
                <b-btn variant="primary" v-bind:disabled="loading" class="ml-1" @click="createHotline">
                    <template v-if="loading">
                        Creating...
                    </template>
                    <template v-else>
                        Create
                    </template>
                </b-btn>
            </div>
        </b-modal>
        <b-modal
            id="edit-hotline"
            title="Edit Hotline"
            @shown="clearForm"
            ref="updateModal"
            centered>
            <b-container fluid>
                <div class="modal-form">
                    <b-form>
                        <b-row no-gutters>
                            <b-col sm="12" md="3">
                                <h6 class="main-label">Hotline No.</h6>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    label="Landline or Mobile No."
                                    label-for="hotline"
                                    :state="isValid('hotline')"
                                    :invalid-feedback="errorMessage('hotline')"
                                    class="secondary-label">
                                    <b-form-input
                                        type="text"
                                        v-model="hotline.hotline"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col>
                                <hr class="form-divider">
                            </b-col>
                        </b-row>
                        <b-row no-gutters>
                            <b-col sm="12" md="3">
                                <h6 class="main-label">Visibility</h6>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    label="Publish in App"
                                    label-for="visibility"
                                    class="secondary-label">
                                    <switches
                                        v-model="hotline.visibility"
                                        theme="custom"
                                        color="primary"
                                        type-bold="true"
                                        text-enabled="On"
                                        text-disabled="Off">
                                    </switches>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <input type="hidden" v-model="uuid" />
                    </b-form>
                </div>
            </b-container>
            <div slot="modal-footer">
                <b-btn variant="ghost" v-bind:disabled="loading" @click="handleCancel('edit-hotline')" class="mr-1 btn-cancel">
                    Cancel
                </b-btn>
                <b-btn variant="primary" v-bind:disabled="loading" class="ml-1" @click="updateHotline">
                    <template v-if="loading">
                        Updating...
                    </template>
                    <template v-else>
                        Update
                    </template>
                </b-btn>
            </div>
        </b-modal>
        <b-modal
            id="delete-hotline"
            title="Delete Hotline"
            ref="deleteModal"
            centered>
            <p class="text-center">Are you sure you want to delete this hotline?</p>
            <div slot="modal-footer">
                <b-btn variant="ghost" v-bind:disabled="loading" @click="handleCancel('delete-hotline')" class="mr-1 btn-cancel">
                    Cancel
                </b-btn>
                <b-btn variant="primary" v-bind:disabled="loading" class="ml-1" @click="deleteHotline">
                    <template v-if="loading">
                        Deleting...
                    </template>
                    <template v-else>
                        Delete
                    </template>
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Switches from "vue-switches";
import { mapState } from "vuex";

const hotlines = [
    {
        hotline_no: "02 3456789",
        visibility: false
    },
    {
        hotline_no: "+63 9172345678",
        visibility: false
    },
    {
        hotline_no: "+63 9172345679",
        visibility: true
    }
];

export default {
    name: "Hotline",
    components: {
        Switches
    },
    data() {
        return {
            currentPage: 1,
            totalRows: hotlines.length,
            hotlines: hotlines,
            fields: [
                {
                    key: "hotline",
                    sortable: true
                },
                {
                    key: "visibility",
                    sortable: false
                },
                {
                    key: "action",
                    sortable: false,
                    variant: "action"
                }
            ],
            form: {
                uuid: "",
                hotline: "",
                visibility: false
            }
        };
    },
    computed: {
        ...mapState("hotlines", [
            "error",
            "errors",
            "uuid",
            "loading",
            "view",
            "list",
            "page",
            "perPage",
            "maxPage",
            "nextPage",
            "prevPage",
            "startList",
            "endList",
            "message",
            "hotline"
        ])
    },
    created: function() {
        this.$store.dispatch("hotlines/getFirstPage");
    },
    methods: {
        isValid(field) {
            // if (this.errors != null)
                // return this.errors[field] ? false : true;

            return false;
        },
        paginate(page) {
            this.$store.commit("hotlines/setPage", page);
            this.$store.dispatch("hotlines/getList");
        },
        clearForm() {
            this.form.hotline = "";
            this.form.visibility = "";
            this.$store.commit("hotlines/setErrorDefault");
        },
        createHotline(evt) {
            evt.preventDefault();
            let _this = this;

            this.$store.commit("hotlines/setHotline", this.form);
            this.$store.dispatch("hotlines/createHotline").then(function() {
                if (_this.error == false) {
                    _this.$refs.createModal.hide();
                    _this.$store.dispatch("hotlines/getFirstPage");
                } else {
                    _this.$refs.createModal.hide();
                }
            });
        },
        getHotline(uuid) {
            this.$root.$emit("bv::show::modal", "edit-hotline");
            this.$store.commit("hotlines/setUuid", uuid);
            this.$store.dispatch("hotlines/getHotline");
        },
        updateHotline(evt) {
            evt.preventDefault();
            let _this = this;

            this.$store.dispatch("hotlines/updateHotline").then(function() {
                if (_this.error == false) {
                    _this.$refs.updateModal.hide();
                    _this.$store.dispatch("hotlines/getFirstPage");
                }
            });
        },
        confirmDelete(uuid) {
            this.$store.commit("hotlines/setUuid", uuid);
            this.$root.$emit("bv::show::modal", "delete-hotline");
        },
        deleteHotline() {
            let _this = this;
            this.$store.dispatch("hotlines/deleteHotline").then(function() {
                if (_this.errors == null) {
                    _this.$refs.deleteModal.hide();
                    _this.$store.dispatch("hotlines/getFirstPage");
                }
            });
        },
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        handleCancel(modal) {
            this.hideModal(modal);
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
    }
};
</script>
